export const GET_COURT_CONFIG_DATA = 'GET_COURT_CONFIG_DATA';
export const GET_COURT_CONFIG_DATA_SUCCESS = 'GET_COURT_CONFIG_DATA_SUCCESS';
export const GET_COURT_CONFIG_DATA_FAILURE = 'GET_COURT_CONFIG_DATA_FAILURE';
export const GET_DEFAULT_COURT_CONFIG_DATA = 'GET_DEFAULT_COURT_CONFIG_DATA';
export const GET_DEFAULT_COURT_CONFIG_DATA_SUCCESS = 'GET_DEFAULT_COURT_CONFIG_DATA_SUCCESS';
export const GET_DEFAULT_COURT_CONFIG_DATA_FAILURE = 'GET_DEFAULT_COURT_CONFIG_DATA_FAILURE';
export const SAVE_COURT_CONFIG_DATA = 'SAVE_COURT_CONFIG_DATA';
export const SAVE_COURT_CONFIG_DATA_SUCCESS = 'SAVE_COURT_CONFIG_DATA_SUCCESS';
export const SAVE_COURT_CONFIG_DATA_FAILURE = 'SAVE_COURT_CONFIG_DATA_FAILURE';
export const UPDATE_FACILITIES_BASED_ON_CONFIG = 'UPDATE_FACILITIES_BASED_ON_CONFIG';
export const UPDATE_SELECTED_FACILITY = 'UPDATE_SELECTED_FACILITY';
export const UPDATE_SHOW_CONFIG_MODAL = 'UPDATE_SHOW_CONFIG_MODAL';
export const UPDATE_SELECTED_DRAW_WITH_MATCHES = 'UPDATE_SELECTED_DRAW_WITH_MATCHES';
export const UPDATE_DRAWS_WITH_SCHEDULED_MATCHES = 'UPDATE_DRAWS_WITH_SCHEDULED_MATCHES';
export const GET_UNSCHEDULED_DRAW_MATCHES = 'GET_UNSCHEDULED_DRAW_MATCHES';
export const GET_UNSCHEDULED_DRAW_MATCHES_SUCCESS = 'GET_UNSCHEDULED_DRAW_MATCHES_SUCCESS';
export const GET_UNSCHEDULED_DRAW_MATCHES_FAILURE = 'GET_UNSCHEDULED_DRAW_MATCHES_FAILURE';
export const UPDATE_DRAWS_LIST = 'UPDATE_DRAWS_LIST';
export const UPDATE_DRAGGING_MATCH = 'UPDATE_DRAGGING_MATCH';
export const UPDATE_SCHEDULED_MATCHES = 'UPDATE_SCHEDULED_MATCHES';
export const UPDATE_UNSCHEDULED_DRAW_MATCHES = 'UPDATE_UNSCHEDULED_DRAW_MATCHES';
export const UPDATE_HAS_TIME_CONFLICTS = 'UPDATE_HAS_TIME_CONFLICTS';
export const GET_SCHEDULED_MATCHES = 'GET_SCHEDULED_MATCHES';
export const GET_SCHEDULED_MATCHES_SUCCESS = 'GET_SCHEDULED_MATCHES_SUCCESS';
export const GET_SCHEDULED_MATCHES_FAILURE = 'GET_SCHEDULED_MATCHES_FAILURE';
export const SAVE_SCHEDULE_MATCH = 'SAVE_SCHEDULE_MATCH';
export const SAVE_SCHEDULE_MATCH_SUCCESS = 'SAVE_SCHEDULE_MATCH_SUCCESS';
export const SAVE_SCHEDULE_MATCH_FAILURE = 'SAVE_SCHEDULE_MATCH_FAILURE';
export const PUBLISH_SCHEDULED_MATCHES = 'PUBLISH_SCHEDULED_MATCHES';
export const PUBLISH_SCHEDULED_MATCHES_SUCCESS = 'PUBLISH_SCHEDULED_MATCHES_SUCCESS';
export const PUBLISH_SCHEDULED_MATCHES_FAILURE = 'PUBLISH_SCHEDULED_MATCHES_FAILURE';
export const REVERT_SCHEDULED_MATCHES = 'REVERT_SCHEDULED_MATCHES';
export const REVERT_SCHEDULED_MATCHES_SUCCESS = 'REVERT_SCHEDULED_MATCHES_SUCCESS';
export const REVERT_SCHEDULED_MATCHES_FAILURE = 'REVERT_SCHEDULED_MATCHES_FAILURE';
export const MATCH_SETTINGS_UPDATE = 'MATCH_SETTINGS_UPDATE';
export const MATCH_SETTINGS_UPDATE_FAILURE = 'MATCH_SETTINGS_UPDATE_FAILURE';
export const MATCH_SETTINGS_UPDATE_SUCCESS = 'MATCH_SETTINGS_UPDATE_SUCCESS';
export const UPDATE_SELECTED_MATCH_IDS = 'UPDATE_SELECTED_MATCH_IDS';
export const DE_SCHEDULE_MATCHES = 'DE_SCHEDULE_MATCHES';
export const DE_SCHEDULE_MATCHES_SUCCESS = 'DE_SCHEDULE_MATCHES_SUCCESS';
export const DE_SCHEDULE_MATCHES_FAILURE = 'DE_SCHEDULE_MATCHES_FAILURE';
export const CLEAR_COURT_SCHEDULAR_DATA = 'CLEAR_COURT_SCHEDULAR_DATA';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const UPDATE_DRAW_MATCH_COUNT = 'UPDATE_DRAW_MATCH_COUNT';
export const ADJUST_SELECTED_MATCHES = 'ADJUST_SELECTED_MATCHES';
export const ADJUST_SELECTED_MATCHES_SUCCESS = 'ADJUST_SELECTED_MATCHES_SUCCESS';
export const ADJUST_SELECTED_MATCHES_FAILURE = 'ADJUST_SELECTED_MATCHES_FAILURE';
export const TOGGLE_SELECT_ALL_MATCHES_ON_COURT = 'TOGGLE_SELECT_ALL_MATCHES_ON_COURT';
